import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "confirmModalHistory",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body p-0" }
const _hoisted_8 = { class: "text-center py-4 mb-4 border-bottom" }
const _hoisted_9 = { class: "row mx-0 px-0 mb-4 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_10 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_11 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { ref, PropType, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import communityPortfoliosServices from '@/services/communities-portfolios.service'

import { COMMUNITY_PORTFOLIOS_STORE } from '@/store/constants'
import dayjs from 'dayjs'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  responseServerError: Function as PropType<() => void | undefined>,
  data: Object as PropType<{
    affiliation: string | number | any
    department: string | any
    position: string | any
    job_type_parent_id: number | string | any
    job_type_child_id: number | string | any
    fromDate: string
    toDate: string
    content: string | any
  }>,
  jobNameParent: String,
  jobNameChild: String,
  departmentName: String,
  idCorporation: String,
  idWork: String,
  reset: {
    type: Function as PropType<() => void | undefined>,
  },
},
  emits: ['onHideModalConfirm'],
  setup(__props, { expose, emit }) {

const props = __props


const router = useRouter()
const store = useStore()



// 2022/09/12 TienNV Failed to delete but successful modal is displayed
const submittingButton = ref<boolean>(false)
const modalConfirm = ref()
const modalSuccess = ref()
const getBack = ref(false)

onMounted(() => {
  const modal = document.getElementById('confirmModalHistory')
  modalConfirm.value = new Modal(modal)
  modalSuccess.value = new Modal(document.getElementById('successModal'))
  modal?.addEventListener('hide.bs.modal', onHideModalConfirm)
})
expose({
  showConfirmModal: (): void => {
    getBack.value = false
    modalConfirm.value.show()
  },
})
const onSubmit = async (): Promise<void> => {
  submittingButton.value = true

  if (!props.idCorporation) {
    try {
      const response = await communityPortfoliosServices.createPortfolios({
        portfolio: {
          portfolio_work_history_corporation_id: props.data?.affiliation,
          department_name: props.data?.department,
          position: props.data?.position,
          job_type_parent_id: props.data?.job_type_parent_id,
          job_type_child_id: props.data?.job_type_child_id,
          start_period: dayjs(props.data?.fromDate).format('YYYY/MM/DD'),
          end_period: props.data?.toDate ? dayjs(props.data?.toDate).format('YYYY/MM/DD') : null,
          content: props.data?.content,
        },
        id: router.currentRoute.value.params.id,
      })

      if (response.status === 200) {
        localStorage.removeItem('checkConfirm')
        store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.CREATE_COMMUNITIES_PORTFOLIOS, {
          portfolio_work_history_corporation_id: props.data?.affiliation,
          department_name: props.data?.department,
          position: props.data?.position,
          job_type_parent_id: props.data?.job_type_parent_id,
          job_type_child_id: props.data?.job_type_child_id,
          start_period: dayjs(props.data?.fromDate).format('YYYY/MM/DD'),
          end_period: props.data?.toDate ? dayjs(props.data?.toDate).format('YYYY/MM/DD') : null,
          content: props.data?.content,
          id: response.data.data.portfolio_work_history_id,
        })
        // props.reset()
        // 2022/09/12 TienNV Failed to delete but successful modal is displayed
        props.responseServerError('')
        modalConfirm.value.hide()
        modalSuccess.value.show()
        setTimeout(() => {
          submittingButton.value = false
        }, 2000)
        return
      } else {
        // localStorage.setItem('serverError', true)
        modalConfirm.value.hide()
        modalSuccess.value.show()
        props.responseServerError('create')
        setTimeout(() => {
          submittingButton.value = false
        }, 2000)
        submittingButton.value = false
      }
    } catch (error: any) {
      console.log('err', error.response)
      // localStorage.setItem('serverError', true)
      modalConfirm.value.hide()
      modalSuccess.value.show()
      submittingButton.value = false
      props.responseServerError('create')
    }
  } else {
    try {
      const response = await communityPortfoliosServices.updatePortfolios({
        portfolio: {
          portfolio_work_history_corporation_id: props.data?.affiliation,
          department_name: props.data?.department,
          position: props.data?.position,
          job_type_parent_id: props.data?.job_type_parent_id,
          job_type_child_id: props.data?.job_type_child_id,
          start_period: dayjs(props.data?.fromDate).format('YYYY/MM/DD'),
          end_period: props.data?.toDate ? dayjs(props.data?.toDate).format('YYYY/MM/DD') : null,
          content: props.data?.content,
        },
        id: props.idWork,
      })

      if (response.status === 200) {
        localStorage.removeItem('checkConfirm')
        store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.UPDATE_COMMUNITIES_PORTFOLIOS, {
          portfolio_work_history_corporation_id: props.data?.affiliation,
          department_name: props.data?.department,
          position: props.data?.position,
          job_type_parent_id: props.data?.job_type_parent_id,
          job_type_child_id: props.data?.job_type_child_id,
          start_period: dayjs(props.data?.fromDate).format('YYYY/MM/DD'),
          end_period: props.data?.toDate ? dayjs(props.data?.toDate).format('YYYY/MM/DD') : null,
          content: props.data?.content,
          old_corporation_id: props?.idCorporation,
          id: props.idWork,
        })
        // props.reset()
        // 2022/09/12 TienNV Failed to delete but successful modal is displayed
        props.responseServerError('')
        modalConfirm.value.hide()
        modalSuccess.value.show()
        setTimeout(() => {
          submittingButton.value = false
        }, 2000)
        return
      } else {
        // localStorage.setItem('serverError', true)
        props.responseServerError('update')
        modalConfirm.value.hide()
        modalSuccess.value.show()
        submittingButton.value = false
      }
    } catch (error: any) {
      console.log('err', error.response)
      // localStorage.setItem('serverError', true)
      modalConfirm.value.hide()
      modalSuccess.value.show()
      submittingButton.value = false
      props.responseServerError('update')
    }
  }
}
const onHideModalConfirm = () => {
  emit('onHideModalConfirm', getBack.value)
}

const getBackConfirmModal = () => {
  getBack.value = true
  modalConfirm.value?.hide()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.idWork ? _unref(translate)('editWorkHistory') : _unref(translate)('addWorkHistory')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)(!props.idCorporation ? 'SG43confirmHistory' : 'SG43confirmHistoryEdit')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(Button, {
                  title: _unref(translate)('back'),
                  type: 'secondary',
                  className: 'button-confirm-modal',
                  onClick: getBackConfirmModal
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(Button, {
                  class: "button-submit",
                  title: __props.idWork ? '更新する' : '登録する',
                  onClick: onSubmit,
                  loading: submittingButton.value,
                  disabled: submittingButton.value,
                  type: 'secondary'
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})